import { render, staticRenderFns } from "./MedicinePricing.vue?vue&type=template&id=8a18e1b6"
import script from "./MedicinePricing.vue?vue&type=script&lang=js"
export * from "./MedicinePricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports